import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { publicPath } from '../../vue.config'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/person',
        name: 'Person',
        component: () =>
            import(/* webpackChunkName: "person" */ '../views/Person.vue')
    },
    {
        path: '/genres',
        name: 'Genres',
        component: () =>
            import(/* webpackChunkName: "genres" */ '../views/Genres.vue')
    },
    {
        path: '/feelings',
        name: 'Feelings',
        component: () =>
            import(/* webpackChunkName: "feelings" */ '../views/Feelings.vue')
    },
    {
        path: '/vacation',
        name: 'Vacation',
        component: () =>
            import(/* webpackChunkName: "vacation" */ '../views/Vacation.vue')
    },
    {
        path: '/season',
        name: 'Season',
        component: () =>
            import(/* webpackChunkName: "season" */ '../views/Season.vue')
    },
    {
        path: '/loading',
        name: 'Loading',
        component: () =>
            import(/* webpackChunkName: "loading" */ '../views/Loading.vue')
    },
    {
        path: '/results',
        name: 'Results',
        component: () =>
            import(/* webpackChunkName: "results" */ '../views/Results.vue')
    },
    {
        path: '/:catchAll(.*)',
        name: 'Error',
        component: () =>
            import(/* webpackChunkName: "Error" */ '../views/Error.vue')
    }
]

const router = new VueRouter({
    base: publicPath,
    mode: 'history',
    routes
})

export default router
